import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ea89b370"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trend-ls"
};
const _hoisted_2 = {
  class: "trend-top"
};
const _hoisted_3 = {
  class: "trend-title"
};
const _hoisted_4 = {
  key: 0,
  class: "trend-hint"
};
const _hoisted_5 = {
  class: "chips-bar"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "chips-label"
}, "机构", -1));
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "chip-line"
};
const _hoisted_9 = {
  class: "chips-bar"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "chips-label"
}, "选项", -1));
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "chips-bar"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "chips-label"
}, "节点", -1));
import { ref, nextTick, onMounted, onBeforeUnmount } from 'vue';
import * as echarts from 'echarts';
const KEY_POINTS = 12;

/**
 * 简化为关键节点：保留首(初盘)、尾(终盘)；优先保留「盘口升降」「水位突变」的点；
 * 不足/过多时再按“重要性+时间覆盖”补到 ~KEY_POINTS。
 * 欧盘无盘口 → 按时间均匀取关键点。
 */

export default {
  __name: 'HandicapTrendView',
  setup(__props, {
    expose: __expose
  }) {
    const visible = ref(false);
    const title = ref('');
    const rotateNeeded = ref(false); // 竖屏时整层旋转成横屏布局

    const marketIndex = ref(0); // 0亚盘 / 1欧盘 / 2大小
    const pool = ref([]); // 全部机构 [{ name, rows(时间升序), hasData }]
    const main = ref(''); // 当前(固定)机构名
    const on = ref({}); // 额外叠加机构开关
    const selCol = ref(null); // 单选指标 key；null=全部展示
    const useAll = ref(false); // false=关键节点简化(初盘/变盘/终盘 ~10)，true=全部变动点

    // 多机构多指标时保证「每条线一种颜色」的调色板（按可见公司x选项顺序分配）
    const PALETTE = ['#f87171', '#38bdf8', '#34d399', '#fbbf24', '#a78bfa', '#f472b6', '#fb923c', '#2dd4bf', '#60a5fa', '#4ade80', '#c084fc', '#facc15', '#22d3ee', '#e879f9', '#818cf8', '#fda4af'];
    const chartEl = ref(null);
    let chart = null;
    let ro = null;

    // 机构线型：主公司 = 加粗实线；叠加机构按其在机构列表里的位置取 虚/点线，稳定可识别
    const MAIN_LINE = {
      type: 'solid',
      w: 3,
      a: 1,
      u: '━━━'
    };
    const EXTRA_LINE = [{
      type: 'dashed',
      w: 2.2,
      a: 1,
      u: '┅┅┅'
    }, {
      type: 'dotted',
      w: 2.2,
      a: 1,
      u: '┈┈┈'
    }, {
      type: 'dashed',
      w: 1.2,
      a: 0.75,
      u: '┅┅┅'
    }, {
      type: 'dotted',
      w: 1.3,
      a: 0.75,
      u: '┈┈┈'
    }, {
      type: 'dashed',
      w: 0.9,
      a: 0.5,
      u: '┅┅┅'
    }];
    const tokenOf = c => c.name === main.value ? MAIN_LINE : EXTRA_LINE[Math.max(0, pool.value.findIndex(p => p.name === c.name)) % EXTRA_LINE.length];
    const lineSample = c => c.hasData ? tokenOf(c).u : '—';

    /**
     * 三市场图表规格：颜色表达「指标(胜平负/主客水/盘口)」，与参考版一致
     */
    const MARKET_SPEC = [{
      name: '亚盘',
      waterMin: 0.7,
      waterMax: 1.2,
      hcpMin: -0.8,
      hcpMax: -0.1,
      hcpText: 'asia',
      series: [{
        key: 'value2',
        name: '主队水位',
        color: '#38bdf8',
        fill: 'rgba(56,189,248,0.15)'
      }, {
        key: 'value4',
        name: '客队水位',
        color: '#a78bfa',
        fill: 'rgba(167,139,250,0.15)'
      }, {
        key: 'value3',
        name: '盘口值',
        color: '#fb923c',
        hcp: true
      }]
    }, {
      name: '欧盘',
      series: [{
        key: 'value2',
        name: '胜',
        color: '#f87171'
      }, {
        key: 'value3',
        name: '平',
        color: '#fbbf24'
      }, {
        key: 'value4',
        name: '负',
        color: '#38bdf8'
      }]
    }, {
      name: '大小',
      waterMin: 0.7,
      waterMax: 1.2,
      hcpMin: 2.0,
      hcpMax: 3.0,
      hcpText: 'num',
      series: [{
        key: 'value2',
        name: '大球',
        color: '#34d399',
        fill: 'rgba(52,211,153,0.12)'
      }, {
        key: 'value4',
        name: '小球',
        color: '#f87171',
        fill: 'rgba(248,113,113,0.12)'
      }, {
        key: 'value3',
        name: '盘口',
        color: '#fb923c',
        hcp: true
      }]
    }];
    const mkSpec = () => MARKET_SPEC[marketIndex.value] || MARKET_SPEC[0];
    const mkKeys = () => mkSpec().series.map(s => s.key);
    const colLabel = k => {
      const s = mkSpec().series.find(x => x.key === k);
      return s ? s.name : k;
    };
    const toNum = v => {
      const n = Number(v);
      return isNaN(n) ? null : n;
    };

    /** 时间 "yyyy-MM-dd HH:mm" -> 两行标签（日期 \n 时刻）；凌晨00:00 只显示日期 */
    const fmtTick = v1 => {
      if (!v1) return '';
      const p = String(v1).split(' ');
      const d = (p[0] || '').slice(5);
      const t = (p[1] || '').slice(0, 5);
      return t && t !== '00:00' ? d + '\n' + t : d;
    };
    const pad2 = n => String(n).padStart(2, '0');
    const fmtMs = ms => {
      const d = new Date(ms);
      const dstr = pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
      const tstr = pad2(d.getHours()) + ':' + pad2(d.getMinutes());
      return tstr !== '00:00' ? dstr + '\n' + tstr : dstr;
    };

    /** 安全解析 "yyyy-MM-dd HH:mm"(含仅日期) 为毫秒；失败返回 null（iOS 兼容） */
    const parseMs = v1 => {
      if (!v1) return null;
      const d = new Date(String(v1).trim().replace(' ', 'T'));
      return isNaN(d.getTime()) ? null : d.getTime();
    };

    /** 亚盘 tooltip：负=客让、正=主让（与参考版一致）；0=平手盘 */
    const asiaHcpTxt = v => {
      if (v == null || isNaN(v)) return '-';
      if (v === 0) return '平手盘';
      return v < 0 ? '客让' + Math.abs(v).toFixed(2) : '主让' + v.toFixed(2);
    };

    /** 该序列名是否为“盘口”线 */
    const isHcpName = name => name === '盘口值' || name === '盘口' || name.endsWith('·盘口值') || name.endsWith('·盘口');

    /** 轴范围：在给定窗口基础上把数据包进来，避免深盘被裁切 */
    const clampAxis = (data, lo, hi, pad) => {
      const nums = (data || []).filter(x => x != null);
      if (!nums.length) return lo == null ? {} : {
        min: lo,
        max: hi
      };
      const mn = Math.min(...nums);
      const mx = Math.max(...nums);
      if (lo == null) return {
        min: mn - pad,
        max: mx + pad
      };
      return {
        min: Math.min(lo, mn - pad),
        max: Math.max(hi, mx + pad)
      };
    };
    const visibleCompanies = () => pool.value.filter(c => c.hasData && (c.name === main.value || on.value[c.name]));

    /** 关键节点数上限：初盘/重要变盘/终盘 约 10 个，不必写死 */
    const downsample = rows => {
      const list = rows || [];
      const len = list.length;
      if (len <= KEY_POINTS) return list;
      const isEuro = marketIndex.value === 1;
      const chosen = new Set([0, len - 1]);

      // 盘口升降候选(按幅度降序，幅度大优先保)
      if (!isEuro) {
        const hcpCand = [];
        for (let i = 1; i < len; i++) {
          const a = Number(list[i - 1].value3);
          const b = Number(list[i].value3);
          if (!isNaN(a) && !isNaN(b) && Math.abs(a - b) > 0.001) hcpCand.push(i);
        }
        hcpCand.sort((x, y) => Math.abs(Number(list[y].value3) - Number(list[y - 1].value3)) - Math.abs(Number(list[x].value3) - Number(list[x - 1].value3)));
        for (const i of hcpCand) {
          if (chosen.size < KEY_POINTS) chosen.add(i);
        }
      }

      // 水位突变权重
      const w = new Array(len).fill(0);
      if (!isEuro) {
        for (let i = 1; i < len; i++) {
          const dj = Math.max(Math.abs(Number(list[i].value2) - Number(list[i - 1].value2)), Math.abs(Number(list[i].value4) - Number(list[i - 1].value4)));
          if (!isNaN(dj)) {
            if (dj >= 0.1) w[i] = 4;else if (dj >= 0.06) w[i] = 2.5;else if (dj >= 0.03) w[i] = 1;
          }
        }
      }

      // 用「重要性 + 离已选点距离」贪心补齐到 ~KEY_POINTS，保证主线又不丢时间段
      while (chosen.size < KEY_POINTS) {
        let best = -1;
        let bv = -Infinity;
        for (let i = 1; i < len - 1; i++) {
          if (chosen.has(i)) continue;
          let near = Infinity;
          for (const ci of chosen) near = Math.min(near, Math.abs(i - ci));
          const val = w[i] * 2 + near;
          if (val > bv) {
            bv = val;
            best = i;
          }
        }
        if (best === -1) break;
        chosen.add(best);
      }
      return [...chosen].sort((a, b) => a - b).map(i => list[i]);
    };
    const rowsOf = c => useAll.value ? c.rows : downsample(c.rows);

    /** 多机构：合并各家样本时间为统一 master */
    const buildMaster = vis => {
      const set = new Set();
      vis.forEach(c => c.rows.forEach(r => {
        const ms = parseMs(r.value1);
        if (ms != null) set.add(ms);
      }));
      return [...set].sort((a, b) => a - b);
    };

    /** 某公司序列 as-of 前值填充到 master 时间轴，返回 v2/v3/v4 三个等长数组 */
    const align = (rows, master) => {
      const times = rows.map(r => parseMs(r.value1));
      const v2 = [];
      const v3 = [];
      const v4 = [];
      let j = 0;
      let cur = null;
      for (const ms of master) {
        while (j < rows.length && times[j] != null && times[j] <= ms) {
          cur = rows[j];
          j++;
        }
        v2.push(cur ? toNum(cur.value2) : null);
        v3.push(cur ? toNum(cur.value3) : null);
        v4.push(cur ? toNum(cur.value4) : null);
      }
      return {
        v2,
        v3,
        v4
      };
    };
    const render = () => {
      const el = chartEl.value;
      if (!el) return;
      const mk = mkSpec();
      const hasHcp = !!mk.hcpText;
      const vis = visibleCompanies();
      if (!vis.length) return;
      if (echarts.getInstanceByDom(el)) echarts.getInstanceByDom(el).dispose();
      chart = echarts.init(el);
      const single = vis.length === 1;
      const selected = selCol.value ? mk.series.filter(s => s.key === selCol.value) : mk.series;
      const labels = [];
      const series = [];
      const leftVals = [];
      const rightVals = [];
      if (single) {
        // ===== 单家：按指标上色（与历史外观一致），只画已选选项 =====
        const rows = rowsOf(vis[0]);
        rows.forEach(r => labels.push(fmtTick(r.value1)));
        selected.forEach(s => {
          const data = rows.map(r => toNum(r[s.key]));
          const isHcp = !!s.hcp;
          data.forEach(v => (isHcp ? rightVals : leftVals).push(v));
          const base = {
            name: s.name,
            type: 'line',
            data,
            yAxisIndex: isHcp ? 1 : 0,
            smooth: !isHcp,
            step: isHcp ? 'end' : undefined,
            symbol: 'circle',
            showSymbol: true,
            symbolSize: isHcp ? 5 : 4,
            lineStyle: isHcp ? {
              width: 2,
              type: 'dashed',
              color: s.color
            } : {
              width: 2.5,
              color: s.color
            },
            itemStyle: {
              color: s.color
            },
            emphasis: {
              focus: 'series'
            },
            z: isHcp ? 5 : 1
          };
          if (!isHcp && s.fill) base.areaStyle = {
            color: s.fill
          };
          series.push(base);
        });
      } else {
        // ===== 多家对比：每条可见线分配一种颜色；主公司加粗实线、其它公司虚/点线 =====
        const master = buildMaster(vis.map(c => ({
          rows: rowsOf(c)
        })));
        master.forEach(ms => labels.push(fmtMs(ms)));
        let colorIdx = 0;
        vis.forEach(c => {
          const tok = tokenOf(c);
          const isMain = c.name === main.value;
          const a = align(rowsOf(c), master);
          const vals = {
            value2: a.v2,
            value3: a.v3,
            value4: a.v4
          };
          selected.forEach(s => {
            const data = vals[s.key];
            if (!data) return;
            data.forEach(v => (s.hcp ? rightVals : leftVals).push(v));
            const color = PALETTE[colorIdx++ % PALETTE.length];
            const name = `${c.name}·${s.name}`;
            series.push({
              name,
              type: 'line',
              data,
              yAxisIndex: s.hcp ? 1 : 0,
              smooth: !s.hcp,
              step: s.hcp ? 'end' : undefined,
              symbol: 'circle',
              showSymbol: true,
              symbolSize: isMain ? 4 : 3,
              connectNulls: true,
              lineStyle: {
                width: tok.w,
                type: tok.type,
                color,
                opacity: tok.a
              },
              itemStyle: {
                color
              },
              emphasis: {
                focus: 'series'
              },
              z: s.hcp ? 5 : 1
            });
          });
        });
      }

      // 坐标轴
      const yAxes = hasHcp ? [{
        type: 'value',
        position: 'left',
        ...clampAxis(leftVals, mk.waterMin, mk.waterMax, 0.05),
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: 'rgba(42,58,85,0.5)'
          }
        },
        axisLabel: {
          color: '#94a3b8',
          fontSize: 11,
          formatter: v => v.toFixed(2)
        }
      }, {
        type: 'value',
        position: 'right',
        ...clampAxis(rightVals, mk.hcpMin, mk.hcpMax, 0.1),
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#fb923c',
          fontSize: 11,
          formatter: v => v.toFixed(2)
        }
      }] : [{
        type: 'value',
        scale: true,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: 'rgba(42,58,85,0.5)'
          }
        },
        axisLabel: {
          color: '#94a3b8',
          fontSize: 11,
          formatter: v => v.toFixed(2)
        }
      }];
      const tooltip = {
        trigger: 'axis',
        backgroundColor: '#1a2234',
        borderColor: '#2a3a55',
        borderWidth: 1,
        padding: [8, 12],
        textStyle: {
          color: '#e2e8f0',
          fontSize: 12
        },
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: 'rgba(148,163,184,0.4)'
          }
        },
        formatter: params => {
          const t = labels[params[0].dataIndex] || '';
          const htmlParts = [`<div style="font-weight:700;color:#e2e8f0;margin-bottom:5px;white-space:pre-line">${t}</div>`];
          params.forEach(p => {
            const v = p.value;
            let txt = '-';
            if (v != null && !isNaN(v)) {
              if (isHcpName(p.seriesName) && mk.hcpText === 'asia') txt = asiaHcpTxt(v);else txt = Number(v).toFixed(2);
            }
            htmlParts.push(`<div style="display:flex;align-items:center;gap:7px;line-height:1.7">
          <span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${p.color}"></span>
          <span style="color:#cbd5e1">${p.seriesName}</span>
          <b style="margin-left:auto;color:#e2e8f0">${txt}</b></div>`);
          });
          return htmlParts.join('');
        }
      };
      const step = Math.max(0, Math.ceil(labels.length / 8) - 1);
      chart.setOption({
        animationDuration: 300,
        tooltip,
        legend: single ? {
          top: 8,
          left: 'center',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 18,
          textStyle: {
            color: '#cbd5e1',
            fontSize: 12
          },
          icon: 'circle'
        } : undefined,
        grid: {
          left: 46,
          right: hasHcp ? 52 : 16,
          top: single ? 46 : 18,
          bottom: 34
        },
        xAxis: {
          type: 'category',
          data: labels,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(42,58,85,0.7)'
            }
          },
          axisLabel: {
            color: '#94a3b8',
            fontSize: 10,
            interval: step
          },
          axisTick: {
            show: false
          }
        },
        yAxis: yAxes,
        dataZoom: [{
          type: 'inside'
        }],
        series
      });
    };
    const toggle = c => {
      if (c.name === main.value || !c.hasData) return;
      on.value[c.name] = !on.value[c.name];
      if (visible.value) nextTick(() => render());
    };

    /** 选项单选：点某指标只看它；再点一下回到「全部」 */
    const chooseCol = k => {
      selCol.value = selCol.value === k ? null : k;
      if (visible.value) nextTick(() => render());
    };

    /** 节点切换：关键点(简化) / 全部 */
    const chooseNodes = all => {
      if (useAll.value === all) return;
      useAll.value = all;
      if (visible.value) nextTick(() => render());
    };

    /** 竖屏 -> 旋转整层(伪横屏)；横屏 -> 正常平铺。以宽高比判断，兼顾手机/桌面 */
    const syncOrientation = () => {
      rotateNeeded.value = window.innerWidth <= window.innerHeight;
      if (visible.value && chart) setTimeout(() => chart.resize(), 220);
    };
    const show = payload => {
      if (!payload) return;
      marketIndex.value = payload.marketIndex || 0;
      let comps = payload.companies;
      if (!comps || !comps.length) {
        comps = [{
          name: payload.companyName || '',
          rows: payload.rows || []
        }];
      }
      pool.value = comps.map(c => {
        const rows = (c.rows || []).slice().sort((a, b) => String(a.value1).localeCompare(String(b.value1)));
        return {
          name: c.name,
          rows,
          hasData: rows.length > 0
        };
      });
      main.value = payload.main || comps[0] && comps[0].name || '';
      on.value = {
        [main.value]: true
      };
      selCol.value = null; // 默认显示全部指标
      useAll.value = false; // 默认关键点(简化)视图
      title.value = main.value + ' · ' + mkSpec().name + ' 盘口走势';
      syncOrientation();
      visible.value = true;
      nextTick(() => {
        render();
        if (ro) ro.disconnect();
        if (chartEl.value) {
          ro = new ResizeObserver(() => {
            if (chart) chart.resize();
          });
          ro.observe(chartEl.value);
        }
      });
    };
    const close = () => {
      visible.value = false;
      if (ro) {
        ro.disconnect();
        ro = null;
      }
      if (chart) {
        chart.dispose();
        chart = null;
      }
    };
    const onOrientationChange = () => syncOrientation();
    onMounted(() => {
      const mql = window.matchMedia('(orientation: landscape)');
      const useMql = typeof mql.addEventListener === 'function';
      useMql ? mql.addEventListener('change', onOrientationChange) : window.addEventListener('orientationchange', onOrientationChange);
      window.addEventListener('resize', onOrientationChange);
    });
    onBeforeUnmount(() => {
      const mql = window.matchMedia('(orientation: landscape)');
      const useMql = typeof mql.removeEventListener === 'function';
      useMql ? mql.removeEventListener('change', onOrientationChange) : window.removeEventListener('orientationchange', onOrientationChange);
      window.removeEventListener('resize', onOrientationChange);
      if (ro) ro.disconnect();
      if (chart) chart.dispose();
    });

    // eslint-disable-next-line no-undef
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [visible.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["trend-mask", {
          'trend-rotate': rotateNeeded.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(title.value), 1), rotateNeeded.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, "↻ 请横屏查看")) : _createCommentVNode("", true), _createElementVNode("span", {
        class: "trend-close",
        onClick: close
      }, "✕")]), _createElementVNode("div", _hoisted_5, [_hoisted_6, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pool.value, c => {
        return _openBlock(), _createElementBlock("span", {
          key: c.name,
          class: _normalizeClass(["chip", {
            'is-main': c.name === main.value,
            'is-on': c.name !== main.value && on.value[c.name],
            disabled: !c.hasData
          }]),
          onClick: $event => toggle(c)
        }, [_createElementVNode("i", _hoisted_8, _toDisplayString(lineSample(c)), 1), _createTextVNode(_toDisplayString(c.name), 1)], 10, _hoisted_7);
      }), 128))]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", {
        class: _normalizeClass(["chip opt", {
          'is-on': selCol.value === null
        }]),
        onClick: _cache[0] || (_cache[0] = $event => chooseCol(null))
      }, "全部", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mkKeys(), k => {
        return _openBlock(), _createElementBlock("span", {
          key: k,
          class: _normalizeClass(["chip opt", {
            'is-on': selCol.value === k
          }]),
          onClick: $event => chooseCol(k)
        }, _toDisplayString(colLabel(k)), 11, _hoisted_11);
      }), 128))]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", {
        class: _normalizeClass(["chip opt", {
          'is-on': !useAll.value
        }]),
        onClick: _cache[1] || (_cache[1] = $event => chooseNodes(false))
      }, "关键点", 2), _createElementVNode("span", {
        class: _normalizeClass(["chip opt", {
          'is-on': useAll.value
        }]),
        onClick: _cache[2] || (_cache[2] = $event => chooseNodes(true))
      }, "全部", 2)]), _createElementVNode("div", {
        ref_key: "chartEl",
        ref: chartEl,
        class: "trend-chart"
      }, null, 512)])], 2)) : _createCommentVNode("", true)]);
    };
  }
};